export interface VideoItem {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  rating: number;
  year: string;
  region: string;
  description: string;
  tags: string[];
  updateEpisode: string;
  isHot: boolean;
}

export interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
}

export interface ArticleItem {
  id: string;
  title: string;
  category: string;
  cover: string;
  summary: string;
  contentHtml: string;
  author: string;
  publishDate: string;
  viewCount: number;
  tags: string[];
}

export const categories: CategoryItem[] = [
  { slug: "dianshiju", name: "电视剧", icon: "ri-tv-line" },
  { slug: "dianying", name: "电影", icon: "ri-movie-line" },
  { slug: "zongyi", name: "综艺", icon: "ri-live-line" },
  { slug: "dongman", name: "动漫", icon: "ri-ghost-line" },
  { slug: "jilupian", name: "纪录片", icon: "ri-film-line" },
];

export const videos: VideoItem[] = [
  {
    id: "v001",
    title: "繁花",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Shanghai%20city%20night%20scene%20with%20golden%20neon%20lights%20reflecting%20on%20river%2C%20dramatic%20cinematic%20mood%2C%20warm%20amber%20tones%2C%202020s%20nostalgia%20aesthetic%2C%20film%20grain%20texture%2C%20rich%20contrast%20and%20atmospheric%20lighting&width=640&height=360&seq=douhua-v001&orientation=landscape",
    rating: 9.5,
    year: "2023",
    region: "中国大陆",
    description: "九十年代的上海，阿宝凭借改革开放的春风，从平凡青年成长为商界后起之秀。在黄河路上，他经历了商海沉浮与人生百态。",
    tags: ["商战", "年代", "剧情"],
    updateEpisode: "更新至30集",
    isHot: true,
  },
  {
    id: "v002",
    title: "庆余年第二季",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=ancient%20Chinese%20palace%20courtyard%20with%20falling%20cherry%20blossom%20petals%2C%20mysterious%20martial%20arts%20atmosphere%2C%20lanterns%20in%20the%20distance%2C%20cinematic%20lighting%20with%20warm%20golden%20hues%2C%20dramatic%20shadows%2C%20epic%20fantasy%20mood&width=640&height=360&seq=douhua-v002&orientation=landscape",
    rating: 9.2,
    year: "2024",
    region: "中国大陆",
    description: "范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣。",
    tags: ["古装", "权谋", "玄幻"],
    updateEpisode: "全36集",
    isHot: true,
  },
  {
    id: "v003",
    title: "狂飙",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=dark%20rainy%20city%20street%20at%20night%20with%20police%20car%20lights%20flashing%2C%20crime%20thriller%20atmosphere%2C%20wet%20asphalt%20reflecting%20red%20and%20blue%20lights%2C%20tense%20mood%2C%20cinematic%20noir%20style%2C%20high%20contrast%20dramatic%20lighting&width=640&height=360&seq=douhua-v003&orientation=landscape",
    rating: 9.1,
    year: "2023",
    region: "中国大陆",
    description: "京海市一线刑警安欣与黑恶势力长达二十年的生死较量，展现了扫黑行动中的惊心动魄。",
    tags: ["刑侦", "扫黑", "剧情"],
    updateEpisode: "全39集",
    isHot: false,
  },
  {
    id: "v004",
    title: "流浪地球2",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=futuristic%20space%20station%20with%20Earth%20visible%20through%20large%20window%2C%20sci-fi%20dramatic%20lighting%2C%20blue%20planet%20glow%2C%20massive%20mechanical%20structures%2C%20epic%20scale%2C%20cinematic%20science%20fiction%20atmosphere%20with%20warm%20interior%20lighting&width=640&height=360&seq=douhua-v004&orientation=landscape",
    rating: 8.9,
    year: "2023",
    region: "中国大陆",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅途，年轻一代挺身而出。",
    tags: ["科幻", "灾难", "冒险"],
    updateEpisode: "HD高清",
    isHot: true,
  },
  {
    id: "v005",
    title: "满江红",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=ancient%20Chinese%20courtyard%20with%20red%20lanterns%20and%20stone%20walls%2C%20historical%20drama%20atmosphere%2C%20narrow%20alleyways%20with%20warm%20candlelight%2C%20mysterious%20shadows%2C%20traditional%20architecture%2C%20cinematic%20suspense%20mood%20with%20deep%20contrast&width=640&height=360&seq=douhua-v005&orientation=landscape",
    rating: 8.5,
    year: "2023",
    region: "中国大陆",
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一群义士为了守护秘密，在宰相府邸中展开了一场暗战。",
    tags: ["悬疑", "历史", "喜剧"],
    updateEpisode: "HD高清",
    isHot: false,
  },
  {
    id: "v006",
    title: "长安三万里",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=ancient%20Tang%20Dynasty%20Changan%20city%20at%20sunset%20with%20golden%20palace%20rooftops%2C%20colorful%20animated%20style%2C%20flowing%20silk%20ribbons%20in%20the%20wind%2C%20poetic%20atmosphere%2C%20warm%20evening%20light%2C%20traditional%20Chinese%20painting%20aesthetic&width=640&height=360&seq=douhua-v006&orientation=landscape",
    rating: 8.7,
    year: "2023",
    region: "中国大陆",
    description: "安史之乱后数年，吐蕃大军入侵西南，大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。",
    tags: ["历史", "诗词", "传记"],
    updateEpisode: "HD高清",
    isHot: false,
  },
  {
    id: "v007",
    title: "乘风破浪的姐姐",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=glamorous%20stage%20with%20sparkling%20lights%20and%20colorful%20spotlights%2C%20music%20performance%20atmosphere%2C%20elegant%20silhouettes%20on%20stage%2C%20warm%20golden%20and%20pink%20lighting%2C%20entertainment%20show%20vibe%2C%20glamorous%20and%20vibrant%20energy&width=640&height=360&seq=douhua-v007&orientation=landscape",
    rating: 8.3,
    year: "2024",
    region: "中国大陆",
    description: "三十位30+女性艺人突破自我，组团PK的全新舞台竞演节目，展现成熟女性的魅力与力量。",
    tags: ["音乐", "竞演", "女性"],
    updateEpisode: "更新至第8期",
    isHot: true,
  },
  {
    id: "v008",
    title: "舌尖上的中国第四季",
    category: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=steaming%20hot%20Chinese%20food%20on%20wooden%20table%20with%20chopsticks%2C%20warm%20kitchen%20atmosphere%2C%20rising%20steam%20in%20golden%20light%2C%20traditional%20cooking%20scene%2C%20rich%20colors%20of%20fresh%20ingredients%2C%20intimate%20documentary%20photography%20style&width=640&height=360&seq=douhua-v008&orientation=landscape",
    rating: 9.3,
    year: "2024",
    region: "中国大陆",
    description: "从美食出发，讲述中国人与自然、与社会的故事。第四季聚焦各地特色食材和烹饪技艺的传承。",
    tags: ["美食", "人文", "传统文化"],
    updateEpisode: "更新至第6集",
    isHot: false,
  },
  {
    id: "v009",
    title: "三体",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=mysterious%20radio%20telescope%20pointing%20at%20starry%20night%20sky%2C%20sci-fi%20atmosphere%20with%20three%20sun%20effect%2C%20dark%20cosmic%20background%2C%20human%20silhouette%20looking%20up%2C%20cold%20blue%20and%20warm%20orange%20contrast%2C%20philosophical%20mood&width=640&height=360&seq=douhua-v009&orientation=landscape",
    rating: 8.8,
    year: "2023",
    region: "中国大陆",
    description: "纳米科学家汪淼被警官史强带到了联合作战中心，潜入科学边界组织进行调查，揭开了地外文明的秘密。",
    tags: ["科幻", "悬疑", "剧情"],
    updateEpisode: "全30集",
    isHot: false,
  },
  {
    id: "v010",
    title: "热辣滚烫",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=boxing%20ring%20with%20dramatic%20spotlight%20from%20above%2C%20warm%20golden%20light%20on%20canvas%2C%20inspiring%20sports%20atmosphere%2C%20dust%20particles%20floating%20in%20light%20beam%2C%20cinematic%20motivational%20mood%2C%20empty%20ring%20waiting%20for%20fighter&width=640&height=360&seq=douhua-v010&orientation=landscape",
    rating: 8.2,
    year: "2024",
    region: "中国大陆",
    description: "乐莹宅家多年，无所事事。在命运的几番捉弄后，她决定换一种方式生活，勇敢踏上拳击赛场。",
    tags: ["喜剧", "运动", "励志"],
    updateEpisode: "HD高清",
    isHot: false,
  },
  {
    id: "v011",
    title: "斗罗大陆II绝世唐门",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=magical%20forest%20with%20glowing%20spirit%20rings%20floating%2C%20fantasy%20animation%20style%2C%20mystical%20creatures%20in%20the%20distance%2C%20vibrant%20emerald%20and%20golden%20colors%2C%20adventure%20atmosphere%2C%20enchanted%20world%20with%20sparkles&width=640&height=360&seq=douhua-v011&orientation=landscape",
    rating: 8.6,
    year: "2024",
    region: "中国大陆",
    description: "霍雨浩自幼在公爵府受尽欺凌，凭借自身努力和机遇，一步步成长为强大的魂师。",
    tags: ["热血", "玄幻", "冒险"],
    updateEpisode: "更新至68集",
    isHot: true,
  },
  {
    id: "v012",
    title: "奔跑吧兄弟",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=outdoor%20amusement%20park%20with%20colorful%20obstacles%20and%20games%2C%20sunny%20day%20vibrant%20atmosphere%2C%20fun%20group%20activity%20scene%2C%20bright%20green%20grass%20and%20blue%20sky%2C%20energetic%20and%20playful%20mood%2C%20reality%20show%20style&width=640&height=360&seq=douhua-v012&orientation=landscape",
    rating: 8.0,
    year: "2024",
    region: "中国大陆",
    description: "固定成员与嘉宾一起前往各地，完成各种趣味挑战任务，为观众带来欢乐。",
    tags: ["户外", "真人秀", "搞笑"],
    updateEpisode: "更新至第10期",
    isHot: false,
  },
];

export const articles: ArticleItem[] = [
  {
    id: "a001",
    title: "2024年最值得期待的国产剧大盘点：悬疑、古装、都市一网打尽",
    category: "zixun",
    cover: "https://readdy.ai/api/search-image?query=film%20clapperboard%20on%20wooden%20table%20with%20warm%20studio%20lighting%2C%20movie%20scripts%20scattered%20around%2C%20cinematic%20behind-the-scenes%20atmosphere%2C%20golden%20evening%20light%20through%20window%2C%20creative%20filmmaking%20vibe%2C%20professional%20photography&width=800&height=450&seq=douhua-a001&orientation=landscape",
    summary: "盘点2024年度即将上线的国产电视剧，涵盖悬疑、古装、都市等多种类型，每一部都值得期待。",
    contentHtml: "<p>2024年的国产剧市场可谓百花齐放，从年初到年尾，各大平台纷纷推出了自己的重磅作品。本文将为大家盘点本年度最值得期待的几部国产剧。</p><h2>一、悬疑题材持续发力</h2><p>继《狂飙》《漫长的季节》之后，悬疑剧已成为国产剧最受欢迎的类型之一。今年有多部重量级悬疑剧等待播出，演员阵容和制作班底都非常强大。</p><h2>二、古装剧焕发新生</h2><p>古装剧不再是简单的宫廷争斗和权谋博弈，越来越多的作品开始融入奇幻、武侠、历史等元素，呈现出更加多元化的面貌。</p><h2>三、都市情感剧温暖人心</h2><p>都市剧更加贴近现实生活，聚焦当代年轻人的职场、情感和成长，引发观众强烈共鸣。</p><p>豆花视频将持续为您追踪这些精彩剧集的最新动态，敬请关注。</p>",
    author: "豆花小编",
    publishDate: "2024-07-28",
    viewCount: 158200,
    tags: ["国产剧", "2024", "推荐"],
  },
  {
    id: "a002",
    title: "深度解析《繁花》：王家卫镜头下的上海往事与时代记忆",
    category: "yingping",
    cover: "https://readdy.ai/api/search-image?query=vintage%20Shanghai%20street%20with%20old%20style%20shop%20signs%2C%20warm%20amber%20street%20lamps%2C%20retro%20aesthetic%2C%20nostalgic%201990s%20Chinese%20atmosphere%2C%20wet%20cobblestone%20road%20after%20rain%2C%20cinematic%20mood%20with%20shallow%20depth%20of%20field&width=800&height=450&seq=douhua-a002&orientation=landscape",
    summary: "《繁花》不仅是一部电视剧，更是一封写给九十年代上海的情书。让我们深入王家卫的光影世界。",
    contentHtml: "<p>当王家卫首次执导电视剧的消息传出时，整个影视圈都为之震动。这位以独特的影像美学著称的导演，将如何驾驭长篇叙事？</p><h2>光影中的上海</h2><p>在《繁花》中，王家卫延续了他标志性的视觉风格：精致的构图、饱和的色彩、缓慢的运镜。但与以往不同的是，这次他把镜头对准了九十年代的上海——一个充满欲望与希望的大时代。</p><h2>时代群像</h2><p>剧中的每个角色都是一个时代的缩影。阿宝的奋斗、玲子的精明、汪小姐的执着……这些人物交织在一起，构成了一幅生动的时代画卷。</p><h2>音乐与叙事</h2><p>配乐同样是《繁花》的一大亮点。从老上海的时代曲到九十年代的流行金曲，音乐不仅营造了氛围，更推动了叙事。</p><p>豆花视频推荐指数：★★★★★</p>",
    author: "豆花影评人",
    publishDate: "2024-07-25",
    viewCount: 236500,
    tags: ["繁花", "影评", "王家卫"],
  },
  {
    id: "a003",
    title: "从《流浪地球》到《三体》：中国科幻影视的崛起之路",
    category: "zixun",
    cover: "https://readdy.ai/api/search-image?query=giant%20spaceship%20engine%20glowing%20with%20blue%20flame%20against%20starry%20cosmos%2C%20sci-fi%20epic%20scale%2C%20earth%20visible%20in%20distance%2C%20dramatic%20celestial%20lighting%2C%20awe-inspiring%20space%20exploration%20atmosphere%2C%20cinematic%20grandeur&width=800&height=450&seq=douhua-a003&orientation=landscape",
    summary: "中国科幻影视经过多年积累终于迎来爆发，从大银幕到小荧屏，科幻题材正在成为中国影视的新名片。",
    contentHtml: "<p>2019年，《流浪地球》以46亿票房震惊业界，被媒体称为'中国科幻电影元年'。五年过去，中国科幻影视已经走出了自己的道路。</p><h2>技术突破</h2><p>从《流浪地球》到《三体》，中国特效团队在视效技术上取得了巨大进步。越来越多的硬核科幻场景得以在银幕上完美呈现。</p><h2>故事内核</h2><p>中国科幻作品最独特的地方在于融入了东方哲学。集体主义、家国情怀、文明延续——这些主题在西方科幻中很少如此深度地探讨。</p><h2>未来展望</h2><p>随着越来越多的资本和人才涌入科幻领域，我们有理由相信，中国科幻影视的黄金时代才刚刚开始。</p><p>豆花视频将持续关注中国科幻影视的最新动态。</p>",
    author: "豆花科技观察",
    publishDate: "2024-07-20",
    viewCount: 189300,
    tags: ["科幻", "流浪地球", "三体", "国产影视"],
  },
  {
    id: "a004",
    title: "动漫推荐：2024年国产动画佳作，每一部都值得二刷",
    category: "tuijian",
    cover: "https://readdy.ai/api/search-image?query=colorful%20animated%20Chinese%20mythological%20scene%20with%20floating%20mountains%20and%20waterfalls%2C%20ink%20wash%20painting%20style%20mixed%20with%203D%2C%20magical%20creatures%2C%20vibrant%20colors%2C%20artistic%20animation%20aesthetic%2C%20dreamlike%20atmosphere&width=800&height=450&seq=douhua-a004&orientation=landscape",
    summary: "国产动画近年来质量飙升，从3D玄幻到2D古风，令人惊艳的作品层出不穷。来看看这些不容错过的佳作。",
    contentHtml: "<p>曾经，国产动画在很多人眼中还是'低幼'的代名词。但近五年来，这个刻板印象已经被彻底打破了。</p><h2>3D动画的崛起</h2><p>以《斗罗大陆》《完美世界》为代表的3D玄幻动画，在建模精度、动作流畅度和特效表现上都已经达到了国际水准。</p><h2>2D动画的回归</h2><p>《长安三万里》《深海》等2D作品则展现了中国动画人在美术风格上的独特追求，融合传统水墨与现代技术，创造出令人惊叹的视觉效果。</p><h2>故事为王</h2><p>无论技术如何进步，好故事始终是动画的核心。2024年的国产动画在叙事深度上也有了显著提升。</p><p>豆花视频为您精选以上佳作，欢迎在线观看。</p>",
    author: "豆花动漫控",
    publishDate: "2024-07-15",
    viewCount: 125800,
    tags: ["国产动画", "推荐", "动漫"],
  },
  {
    id: "a005",
    title: "综艺节目新趋势：从娱乐到文化，国产综艺的破圈之路",
    category: "zixun",
    cover: "https://readdy.ai/api/search-image?query=colorful%20TV%20studio%20set%20with%20modern%20design%2C%20circular%20stage%20with%20LED%20screens%2C%20warm%20entertainment%20show%20lighting%2C%20audience%20seats%20in%20the%20background%2C%20professional%20broadcast%20atmosphere%2C%20vibrant%20and%20dynamic%20energy&width=800&height=450&seq=douhua-a005&orientation=landscape",
    summary: "国内综艺正在经历从纯娱乐向文化内涵的转型，音乐竞演、文化探索、生活体验等多元类型百花齐放。",
    contentHtml: "<p>回顾过去几年的国产综艺，一个明显的趋势是从'纯娱乐'向'娱乐+文化'的转型。</p><h2>音乐类综艺的创新</h2><p>从《歌手》到《乘风破浪》，音乐类综艺不断推陈出新。更多元化的选手、更精良的舞台制作，让音乐综艺保持了强大的生命力。</p><h2>文化探索类崛起</h2><p>《典籍里的中国》《非遗里的中国》等文化综艺，将传统文化以年轻人喜闻乐见的方式呈现，实现了文化传播与娱乐效果的统一。</p><h2>生活方式类升温</h2><p>慢综艺、旅行综艺、美食综艺……这些聚焦生活方式的节目让观众在快节奏的生活中找到了一份宁静。</p><p>豆花视频为您精选热门综艺，免费在线观看。</p>",
    author: "豆花娱乐观察",
    publishDate: "2024-07-10",
    viewCount: 98700,
    tags: ["综艺", "趋势", "文化"],
  },
  {
    id: "a006",
    title: "观影指南：八月必看高分电影清单，收藏这一篇就够了",
    category: "tuijian",
    cover: "https://readdy.ai/api/search-image?query=classic%20cinema%20theater%20with%20red%20velvet%20seats%20and%20golden%20decor%2C%20large%20white%20screen%20with%20warm%20lighting%2C%20elegant%20old%20Hollywood%20atmosphere%2C%20spotlight%20on%20the%20screen%2C%20nostalgic%20movie%20theater%20vibe&width=800&height=450&seq=douhua-a006&orientation=landscape",
    summary: "八月盛夏，宅家看片正当时。我们为你整理了本月最值得观看的高分电影，类型丰富，总有一部适合你。",
    contentHtml: "<p>八月炎炎夏日，最惬意的事情莫过于吹着空调、捧着西瓜，来看一部好电影。豆花视频为你精心挑选了本月必看片单。</p><h2>动作冒险</h2><p>如果你喜欢肾上腺素飙升的感觉，本月有几部动作大片不容错过。精彩的打斗场面和震撼的视觉效果，一定会让你大呼过瘾。</p><h2>悬疑推理</h2><p>喜欢烧脑的观众也有福了，多部高分悬疑片将挑战你的推理能力。建议准备好笔记本，随时记录线索。</p><h2>温情治愈</h2><p>如果你只想轻松地度过一个下午，我们也有温情治愈的影片推荐。这些电影或许没有宏大的场面，但一定有一颗温暖的心。</p><p>以上影片均在豆花视频免费在线观看，高清不缓冲。</p>",
    author: "豆花选片师",
    publishDate: "2024-08-01",
    viewCount: 87600,
    tags: ["电影推荐", "八月", "高分"],
  },
];